module.exports = __webpack_public_path__ + "img/produit_8.71e28c0c.png";